// Below basicform component is used for generating static filters in every step;
export const getStaticFilters = (
  actuatorType: string,
  isGearboxApplicable: boolean,
) => {
  return {
    1: [
      {
        attributeIdentifier: 'basicForm',
        featureName: 'filter.basicForm.valve',
        displayName: 'Valve type',
        displayComponent: 0,
        component: 'radioGroup',
        translationId: 'filters.valve.displayName.basicForm',
        values: [
          {
            image: 'Ball',
            label: 'Ball valve',
            value: 'ball_valve',
          },
          {
            image: 'Butterfly',
            label: 'Butterfly valve',
            value: 'butterfly_valve',
          },
        ],
      },
    ],
    2: [
      {
        attributeIdentifier: 'basicForm',
        featureName: 'filter.basicForm.actuator',
        displayName: 'Operations type',
        displayComponent: 0,
        component: 'radioGroup',
        translationId: 'filters.actuator.displayName.basicForm',
        values: [
          {
            image: 'Pneumatic',
            label: 'Pneumatic',
            value: 'pneumatic_actuator',
          },
          {
            image: 'Electric',
            label: 'Electric',
            value: 'electric_actuator',
          },
          ...(isGearboxApplicable === true
            ? [
                {
                  image: 'Gearbox',
                  label: 'Gearbox',
                  value: 'gearbox',
                },
              ]
            : []),
        ],
      },
      ...(actuatorType === 'pneumatic_actuator'
        ? [
            {
              attributeIdentifier: 'ActuatorFunction',
              featureName: 'filter.function.actuator',
              displayName: 'Actuator function',
              displayComponent: 1,
              component: 'radioGroup',
              translationId: 'filters.actuator.displayName.ActuatorFunction',
              values: [
                {
                  label: 'Double acting',
                  value: 'double_acting',
                },
                {
                  label: 'Single acting, spring closed',
                  value: 'single_acting',
                },
                {
                  label: 'Single acting, spring open',
                  value: 'single_acting_open',
                },
              ],
            },
          ]
        : []),
      ...(actuatorType !== 'gearbox'
        ? [
            {
              attributeIdentifier: 'ActuatorMediumType',
              featureName: 'filter.mediumType.actuator',
              displayName: 'Medium type',
              displayComponent: 2,
              component: 'radioGroup',
              translationId: 'filters.actuator.displayName.ActuatorMediumType',
              values: [
                {
                  label: 'Liquid',
                  value: 'Liquid',
                },
                {
                  label: 'Dry gasses',
                  value: 'Gas',
                },
                {
                  label: 'Sludges',
                  value: 'Solid',
                },
              ],
            },
          ]
        : []),
      ...(actuatorType === 'pneumatic_actuator'
        ? [
            {
              attributeIdentifier: 'ActuatorSupplyPressure',
              featureName: 'filter.supplyPressure.actuator',
              displayName: 'Supply Pressure',
              displayComponent: 4,
              component: 'radioGroup',
              translationId:
                'filters.actuator.displayName.ActuatorSupplyPressure',
              values: [
                {
                  value: '6bar',
                  label: '6 bar',
                },
                {
                  value: '5.5bar',
                  label: '5.5 bar',
                },
              ],
            },
          ]
        : []),
    ],
    3: [
      {
        attributeIdentifier: 'EGTF_3734__STRING',
        featureName: 'filter.monitoring.valve',
        displayName: 'Monitoring type',
        displayComponent: 0,
        component: 'radioGroup',
        translationId: 'filters.valve.displayName.monitoringType',
        values: [
          {
            label: 'Switch box',
            value: 'switchbox',
          },
          {
            label: 'Dual sensor',
            value: 'dual_sensor',
          },
          ...(actuatorType !== 'gearbox'
            ? [
                {
                  label: 'Positioners',
                  value: 'positioner',
                },
              ]
            : []),
        ],
      },
    ],
    4: [],
  };
};
